import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { techdocsPlugin } from '@backstage/plugin-techdocs';

/**
 * Override the default TechDocs index page so that /docs defaults to the
 * "All" user-list filter instead of "Owned", matching /catalog.
 */
const techDocsPage = PageBlueprint.make({
  params: {
    path: '/docs',
    title: 'Docs',
    routeRef: convertLegacyRouteRef(techdocsPlugin.routes.root),
    loader: () =>
      import('../../components/techdocs/TechDocsIndexPageContent').then(m => (
        <m.TechDocsIndexPageContent />
      )),
  },
});

export const techDocsPageModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techDocsPage],
});
